// extracted by mini-css-extract-plugin
export default {"rowHasBadge":"mB-z","smallCardRow":"nB-z","largeCardRow":"oB-z","productSearchRow":"pB-z","curatedRow":"qB-z"};